import { array, bool, InferType, mixed, number, object, string } from 'yup';

import { SmsOptInSchema } from './smsOptIn/sms-opt-in.yup';
import { DynamicCardActionSchema } from './actions/actions.yup';
import { OfferOverridesSchema } from './overrides/overrides.yup';
import { IneligibleIfMembershipHasRewardConstraintSchema } from './constraints/constraint.yup';
import { IneligibleIfMembershipHasRewardConstraint } from './constraints/constraints.types';

export const ConstraintSchema = mixed<InferType<typeof IneligibleIfMembershipHasRewardConstraintSchema>>()
  .test(
    'dynamic-card-constraint',
    'Includes invalid constraint descriptors',
    (value: unknown): value is IneligibleIfMembershipHasRewardConstraint => {
      return !!IneligibleIfMembershipHasRewardConstraintSchema.isValidSync(value);
    },
  )
  .required()
  .strict();

const DYNAMIC_CARD_CUSTOM_DATA_VERSION = [1] as const; // add new allowed versions of customData to array
type VersionType = (typeof DYNAMIC_CARD_CUSTOM_DATA_VERSION)[number];

export const DynamicCardCustomDataSchema = object({
  version: number<VersionType>().required().strict().oneOf(DYNAMIC_CARD_CUSTOM_DATA_VERSION),
  rank: number().strict().optional(),
  href: string().optional(),
  action: DynamicCardActionSchema.optional(),
  overrides: OfferOverridesSchema.optional(),
  constraints: array().of(ConstraintSchema).optional(),
  smsOptIn: SmsOptInSchema.optional(),
  __debug: bool().strict().optional(),
  // R TODO: get rid of this or move to a better schema
  completeProfileRestricted: bool().strict().optional(),
}).strict();

export const SpinWheelGameCustomDataSchema = DynamicCardCustomDataSchema.shape({
  spinWheelGame: object({
    backgroundImage: string().optional(),
    backgroundPrimaryColor: string().optional(),
    backgroundSecondaryColor: string().optional(),
    borderColor: string().optional(),
    buttonColor: string().optional(),
    buttonTextColor: string().optional(),
    foregroundImage: string().optional(),
    headerText: string().optional(),
    headerTextColor: string().optional(),
    footerTextColor: string().optional(),
    disclaimerTextColor: string().optional(),
    disclaimerBackgroundColor: string().optional(),
    segments: array()
      .of(
        object({
          icon: string().optional(),
          color: string().optional(),
        }).strict(),
      )
      .optional(),
  }).optional(),
});
